import React from 'react';
import './Blog.css';

const blogPosts = [
  {
    title: 'Why MVPs Matter in 2024',
    date: 'May 5, 2024',
    summary:
      'Learn how launching a Minimum Viable Product helps founders reduce risk, validate ideas, and reach market faster.',
    link: '#',
  },
  {
    title: 'Design Tips for Better User Experience',
    date: 'April 28, 2024',
    summary:
      'We break down 5 practical UI/UX design patterns that keep users engaged and improve conversion rates.',
    link: '#',
  },
  {
    title: 'Building with AI: What’s Possible Today',
    date: 'April 20, 2024',
    summary:
      'From chatbots to content generation — see how startups are using AI tools to save time and innovate.',
    link: '#',
  },
  {
    title: 'Case Study: Shopify Order Tracker',
    date: 'April 12, 2024',
    summary:
      'How we built and deployed a custom order tracking system for Shopify that boosted retention by 34%.',
    link: '#',
  },
];

const Blog = () => {
  return (
    <div className="blog-container">
      <div className="blog-hero">
        <h1 className="blog-title">Blog & Insights</h1>
        <p className="blog-subtitle">
          Tips, tools, case studies, and updates from our team to help you build smarter.
        </p>
      </div>

      <div className="blog-posts">
        {blogPosts.map((post, index) => (
          <div className="blog-card" key={index}>
            <h3>{post.title}</h3>
            <span className="blog-date">{post.date}</span>
            <p>{post.summary}</p>
            <a href={post.link} target="_blank" rel="noopener noreferrer">
              Read more →
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog;
